import { MediaAsset, User } from 'shared/@generated/models';

export type OnboardingAccountDetails = Pick<
  OnboardingUserSetupData,
  'first_name' | 'last_name' | 'email'
>;

export type OnboardingUserSetupData = {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  accepts_marketing: boolean | null;
  accepts_data_sharing: boolean | null;
  avatar: MediaAsset | null;
};

export type OnboardingUserSetupField =
  | 'name'
  | 'first_name'
  | 'last_name'
  | 'email'
  | 'accepts_marketing'
  | 'accepts_data_sharing';

export type OnboardingUserSetupPayload = Partial<
  Pick<User, 'first_name' | 'last_name' | 'email' | 'accepts_marketing' | 'accepts_data_sharing'>
>;

export function getInitialOnboardingUserSetupData(user: User): OnboardingUserSetupData {
  return {
    first_name: user.first_name ?? '',
    last_name: user.last_name ?? '',
    email: user.email ?? '',
    phone_number: user.phone_number ?? '',
    accepts_marketing: user.accepts_marketing ?? null,
    accepts_data_sharing: user.accepts_data_sharing ?? null,
    avatar: user.avatar ?? null,
  };
}

export function buildOnboardingUserSetupFieldPayload(
  field: OnboardingUserSetupField,
  data: OnboardingUserSetupData,
): OnboardingUserSetupPayload {
  if (field === 'name') {
    return {
      first_name: data.first_name.trim(),
      last_name: data.last_name.trim(),
    };
  }

  const value = data[field];

  return {
    [field]: typeof value === 'string' ? value.trim() : value,
  };
}
